import React, { forwardRef } from "react";
import "../../css/components/controls/HrnbButton.css";

/**
 * HrnbButton компонент
 * @param {Object} props
 * @param {React.ReactNode} props.children - Содержимое кнопки
 * @param {React.ReactNode} props.icon - Иконка слева от текста
 * @param {string} props.as - HTML тег (button, a, etc.)
 * @param {string} props.className - Дополнительные CSS классы
 * @param {string} props.type - Тип кнопки (button, submit, reset)
 * @param {boolean} props.disabled - Отключенное состояние
 * @param {string} props.variant - Вариант стиля (primary, secondary, danger, outline, etc.)
 * @param {string} props.size - Размер (sm, md, lg)
 */
const HrnbButton = forwardRef(function HrnbButton({
    children,
    icon,
    as = "button",
    className = "",
    type,
    disabled,
    variant = "primary",
    size = "md",
    ...props
}, ref) {
    const Tag = as;
    const hasIcon = !!icon;
    const hasText = !!children;
    const isIconOnly = hasIcon && !hasText;

    return (
        <Tag
            ref={ref}
            className={`hrnb-btn hrnb-btn--${variant} hrnb-btn--${size} ${isIconOnly ? 'hrnb-btn--icon-only' : ''} ${className}`}
            type={as === "button" ? type : undefined}
            disabled={disabled}
            {...props}
        >
            {icon && <span className="hrnb-btn__icon">{icon}</span>}
            {children && <span className="hrnb-btn__text">{children}</span>}
        </Tag>
    );
});

export default HrnbButton;
